
//変数の設定
var $body = $('body');
//スクロール量を保存
var scrollTop;
var scrollTop2;
//スクロールを固定
function bodyFixedOn() {
  scrollTop = $(window).scrollTop();
  $body.css({'cssText': 'position: fixed;' + 'top: '+(-scrollTop)+'px !important;'});
  // $('header').hide();
}
//スクロールの固定を解除
function bodyFixedOff() {
  $body.css({
    position: '',
    top: ''
  });
  $(window).scrollTop(scrollTop);
  // $('header').show();
}
//裏のモーダルのスクロールを固定
function modalFixedOn() {
  scrollTop2 = $(window).scrollTop();
  $(".modal-container").css({'cssText': 'position: fixed;' + 'top: '+(-scrollTop2)+'px !important;' + 'overflow-y: hidden;'});
}
//裏のモーダルのスクロールの固定を解除
function modalFixedOff() {
  $(".modal-container").css({
    position: '',
    top: '',
    overflowY: '',
  });
  $(window).scrollTop(scrollTop2);
}

function setDefaultCloseList() {

  $(".sort_box.defaultClose .cat_ttl").addClass('active');
  $(".sort_box.defaultClose ul").hide();

}



//SPメニューボタン
$(function(){

    var colmun = localStorage.getItem("col");

  if(colmun == "three"){
		$(".list_inner").removeClass("one");
		$(".column_02").css("opacity", "0.6");
		$(".column_01").css("opacity", "1.0");
  }else{
    	$(".list_inner").addClass("one");
		$(".column_02").css("opacity", "1.0");
		$(".column_01").css("opacity", "0.6");
  }

	//item_list
	$('.list_header .column_01').click(function(){
		$(".list_inner").addClass("one");
		$(".column_02").css("opacity", "1.0");
		$(".column_01").css("opacity", "0.6");
        localStorage.setItem("col", "five");
	});

	$('.list_header .column_02').click(function(){
		$(".list_inner").removeClass("one");
		$(".column_02").css("opacity", "0.6");
		$(".column_01").css("opacity", "1.0");
        localStorage.setItem("col", "three");
    });

	$('.sort_box.color input').click(function(){
		$(this).parent().find("label").toggleClass("active");
	});



	//item_list
	$('.list_header .column_01').click(function(){
		$(".list_inner").addClass("one");
		$(".column_02").css("opacity", "1.0");
		$(".column_01").css("opacity", "0.6");
	});

	$('.list_header .column_02').click(function(){
		$(".list_inner").removeClass("one");
		$(".column_02").css("opacity", "0.6");
		$(".column_01").css("opacity", "1.0");
	});

	$('.sort_box.color input').click(function(){
		$(this).parent("li").find("label").toggleClass("active");
	});

	//item_detail_pc
	var main_txt = $(".item_box_detail .main_img").find("img").attr("alt");
	$(".item_box_detail .img_txt").text(main_txt);

	//item_detail_sp
	var main_txt_sp = $(".item_box_detail .slider img").attr("alt");
	$(".item_box_detail .img_txt_sp").text(main_txt_sp);

	//item_detail_pc
	$('.img_list p').click(function(){
		var src = $(this).find("img").attr("src");
		var txt = $(this).find("img").attr("alt");

		$(".item_box_detail .img_txt").text(txt);

		$(".img_list .img").removeClass("active");
		$(this).toggleClass("active");

		$(".main_img img").css("opacity",0);
		setTimeout(function(){
			$(".main_img img").attr("src",src);
			$(".main_img img").css("opacity",1);

		},200);
	});


	//item_detail_sp
	$('.thumbnail img').click(function(){
		var txt = $(this).attr("alt");
		$(".item_box_detail .img_txt_sp").text(txt);

	});


$('.img_box.sp .slider img').on('touchend', function() {
//	alert("終わり");
    // 処理


	setTimeout(function(){
		var txt = $(".img_box.sp .slick-active").find("img").attr("alt");
		$(".item_box_detail .img_txt_sp").text(txt);
	},300);

})



	$("aside .cat_ttl").click(function(){


		if($(this).hasClass('active')){
      		$(this).removeClass('active');
    	} else {
			$(this).addClass('active');
		}

		$(this).parent(".sort_box").find("ul").slideToggle(300);

	})

	/*modal*/
	$(function(){
		// 変数に要素を入れる
		var open = $('.modal-open'),
			open2 = $('.modal-open-2'),
			close = $('.modal-close'),
			close4 = $('.result-show'),
			container = $('.modal-container');
			container2 = $('.modal-container-2');

		//開くボタンをクリックしたらモーダルを表示する
		open.on('click',function(){
			container.addClass('active');
      bodyFixedOn();
      setDefaultCloseList();
			return false;
		});

		open2.on('click',function(){
			container2.addClass('active');
      bodyFixedOn();
      setDefaultCloseList();
			return false;
		});

		//閉じるボタンをクリックしたらモーダルを閉じる
		close.on('click',function(){
			container.removeClass('active');
			container2.removeClass('active');
      bodyFixedOff();
		});
		close4.on('click',function(){
			container.removeClass('active');
			container2.removeClass('active');
      bodyFixedOff();
		});

		//モーダルの外側をクリックしたらモーダルを閉じる
		$(document).on('click',function(e) {
			if(($(e.target).hasClass('modal-container') || $(e.target).hasClass('modal-container-2')) && !$(e.target).closest('.modal-body').length) {
				container.removeClass('active');
				container2.removeClass('active');
        bodyFixedOff();
			}
		});
	});


	var w = $(window).width()
	if(w < 1021){
		$('.menu').click(function(){
			if($(this).hasClass('active')){
	      		$(this).removeClass('active');
				$('.menu_list').removeClass('active');
				$("body").removeClass("fixed");
	    	} else {
				$('.menu_list').addClass('active');
				$(this).addClass('active');
				$("body").addClass("fixed");
			}
		});
	}else{
		$('.menu').click(function(){
			if($(this).hasClass('active')){
	      		$(this).removeClass('active');
				$('.menu_list').removeClass('active');
	    	} else {
				$('.menu_list').addClass('active');
				$(this).addClass('active');
			}
		});
	}

});

$(function(){
  // 変数に要素を入れる
  var open3 = $('.modal-open-3'),
    close3 = $('.modal-close-3'),
    container3 = $('.modal-container-3');

  var open4 = $('.modal-open-4'),
    close4 = $('.modal-close-4'),
    close4_ctl = $('.modal-close-4_ctl'),
    container4 = $('.modal-container-4');

  //開くボタンをクリックしたらモーダルを表示する
  open3.on('click',function(){
    closeHeaderSearchMenu();
    container3.addClass('active');
    // if(!$('.modal-container.active').length){
      bodyFixedOn();
    // }else{
      // modalFixedOn();
    // }
    return false;
  });
  //開くボタンをクリックしたらモーダルを表示する
  open4.on('click',function(){
    // closeHeaderSearchMenu();
    // container4.addClass('active');
    if(!$('.modal-container.active').length){
      $('.modal-container-4-pc').addClass('active');
      bodyFixedOn();
    }else{
      modalFixedOn();
      $('.modal-container-4-mobile').addClass('active');
    }
    return false;
  });

  //閉じるボタンをクリックしたらモーダルを閉じる
  close3.on('click',function(){
    container3.removeClass('active');
    // if(!$('.modal-container.active').length){
      bodyFixedOff();
    // }else{
      // modalFixedOff();
    // }
  });
  //閉じるボタンをクリックしたらモーダルを閉じる
  close4.on('click',function(){
    container4.removeClass('active');
    if(!$('.modal-container.active').length){
      bodyFixedOff();
    }else{
      modalFixedOff();
    }
  });
  close4_ctl.on('click',function(){
    container4.removeClass('active');
    if(!$('.modal-container.active').length){
      bodyFixedOff();
    }else{
      modalFixedOff();
    }
  });


  //モーダルの外側をクリックしたらモーダルを閉じる
  $(document).on('click',function(e) {
    if($(e.target).hasClass('modal-container-3') && !$(e.target).closest('.modal-body-3').length) {
      container3.removeClass('active');
      // if(!$('.modal-container.active').length){
        bodyFixedOff();
      // }else{
        // modalFixedOff();
      // }
    }else if($(e.target).hasClass('modal-container-4') && !$(e.target).closest('.modal-body-4').length) {
      container4.removeClass('active');
      if(!$('.modal-container.active').length){
        bodyFixedOff();
      }else{
        modalFixedOff();
      }
    }
  });
});

$(function () {
  // メイン画像のオプション
  $(".slider").slick({
    autoplay: false, // 自動再生ON
    arrows: false, // 矢印非表示
    asNavFor: ".thumbnail", // サムネイルと同期
  });
  // サムネイルのオプション
  $(".thumbnail").slick({
    slidesToShow: 4, // サムネイルの表示数
    asNavFor: ".slider", // メイン画像と同期
    focusOnSelect: true, // サムネイルクリックを有効化
    prevArrow: false,
    nextArrow: false,
  });
});



/*a~z*/
$(function(){
  $(".modal-content-4 .link li a, .modal-content-3 .link li a, .modal-content-2 .link li a, .modal-content .link li a").click(function(){
    var string = $(this).attr("class");

    $(".author_select ul").css("display","none");

    $(".modal-content ul"+"."+string).css("display", "flex");
    $(".modal-content-2 ul"+"."+string).css("display", "flex");
    $(".modal-content-3 ul"+"."+string).css("display", "flex");
    $(".modal-content-4 ul"+"."+string).css("display", "flex");

    var dakuten = unescape(escape(string)+'%u3099').normalize();
    var handakuten = unescape(escape(string)+'%u309a').normalize();

    $(".modal-content ul"+"."+dakuten).css("display", "flex");
    $(".modal-content-2 ul"+"."+dakuten).css("display", "flex");
    $(".modal-content-3 ul"+"."+dakuten).css("display", "flex");
    $(".modal-content-4 ul"+"."+dakuten).css("display", "flex");

    $(".modal-content ul"+"."+handakuten).css("display", "flex");
    $(".modal-content-2 ul"+"."+handakuten).css("display", "flex");
    $(".modal-content-3 ul"+"."+handakuten).css("display", "flex");
    $(".modal-content-4 ul"+"."+handakuten).css("display", "flex");

    $(".author_select p span").html(string);

    $(".author_area").scrollTop(0);

    return false;
  })
})

/*item_detail*/
$(function(){
	$(".item_detail dl").eq(1).find("a").click(function(){
		$(".item_detail dl.open").toggleClass("active");
		return false;
	})



	var d_txt_02 = $(".item_box_detail .open .txt_02").text();
	if(d_txt_02 == ""){
		$(".item_box_detail .open .txt_02").remove();
	}
})


// TOPページのSwiper
document.addEventListener('DOMContentLoaded', () => {

  const swiper = new Swiper('.swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,

    autoplay: {
      delay: 5000,
    },
    speed: 600,

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

  });

});


// スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var adjust = 0;
    var speed = 400;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top + adjust;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
});


// header searchボタン押下時
function openHeaderSearchMenu() {
  $('#js-headerSearchMenuBg').show();
  $('#js-headerSearchMenu').slideDown();
}

function closeHeaderSearchMenu() {
  $('#js-headerSearchMenuBg').hide();
  $('#js-headerSearchMenu').slideUp();
}


// 商品一覧 価格フィルター
function onChangePriceCheckbox(num, checked, suffix) {

  const checks = document.querySelectorAll(".filter-price");
  for(c of checks) {
    c.checked = false;
  }

  const checksCtl = document.querySelectorAll(".filter-price-ctl");
  for(c of checksCtl) {
    c.checked = false;
  }

  if(suffix == ''){
    // PC
    if(checked){
      document.getElementById(`Filter-price-${num}`).checked = checked;
      document.getElementById(`Filter-price-${num}-gte`).checked = checked;
      document.getElementById(`Filter-price-${num}-lte`).checked = checked;
      document.getElementById(`Filter-price-${num}-mobile`).checked = checked;
      document.getElementById(`Filter-price-${num}-gte-mobile`).checked = checked;
      document.getElementById(`Filter-price-${num}-lte-mobile`).checked = checked;
    }

  }else{
    // SP
    if(checked){
      document.getElementById(`Filter-price-${num}${suffix}`).checked = checked;
      document.getElementById(`Filter-price-${num}-gte${suffix}`).checked = checked;
      document.getElementById(`Filter-price-${num}-lte${suffix}`).checked = checked;
    }

  }
  
}


function resetFilterColorMobile() {
  const checks = document.querySelectorAll(".filter-color");
  for(c of checks) {
    c.checked = false;
  }
}

// $(function(){
//   //開くボタンをクリックしたらモーダルを表示する
//   $('.sort_box label').on('click',function(){
//     $('label[for="'+$(this).attr('for')+'"]').each((i, e) => {
//       console.log($(e).parent().find('input').checked);
//       $(e).parent().find('input').prop('checked', !$(e).parent().find('input').checked);
//     });
//     return false;
//   });
// });


async function exeBuyNow(variantId, quantity) {

  await addCartItem(variantId, quantity);

  location.href = '/checkout';

}

// カートに追加
function addCartItem(variantId, quantity) {

  var postData = {
    items: [
      {
        id: variantId,
        quantity: quantity
      }
    ]
  };

  return new Promise((resolve, reject) => {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: 'json',
      contentType: 'json',
      data: JSON.stringify(postData),
      headers: {
        'Content-Type': 'application/json'
      },
    }).done(function( data ) {
      console.log(data);
      resolve();

    }).fail(function(XMLHttpRequest, textStatus, errorThrown){
      console.log(errorThrown);
      resolve();

    });
  });

}


function deleteCartItem(variantId) {

  return new Promise((resolve, reject) => {
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: 'json',
      contentType: 'json',
      data: JSON.stringify({id: variantId, quantity: 0}),
      headers: {
        'Content-Type': 'application/json'
      },
    }).done(function( data ) {
      console.log(data);
      resolve();

    }).fail(function(XMLHttpRequest, textStatus, errorThrown){
      console.log(errorThrown);
      reject();
    });
  });

}